import React, { useEffect, useState } from "react";
import Card from "src/components/Cards/Basic";
import axios from "src/config/axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Col, Form, Row } from "react-bootstrap";
import useFilter from "../../../global/useFilter";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import GateLogTable from "../../../components/GateLogTable";
import MultiSelectBox from "../../../components/Forms/MultiSelectBox";

const gateOption = {
  name: "Schranke",
  value: "gate",
};

const GateLogsPage = () => {
  const [gateLogs, setGateLogs] = useState();
  const [accessSystems, setAccessSystems] = useState([]);

  const { pathname } = useLocation();

  const { filter, setFilter } = useFilter(pathname, {
    page: 1,
    search: "",
    order: "created_at_asc",
  });

  const accessSystemOptions = [
    gateOption,
    ...accessSystems.map((accessSystem) => ({
      name: accessSystem.name,
      value: accessSystem.id,
    })),
  ];

  function normalizedFilterValues(selectedValues, options) {
    if (selectedValues === undefined) {
      return undefined;
    }

    const optionValues = options.map((option) => option.value);
    const allSelected =
      optionValues.length === selectedValues.length &&
      optionValues.every((value) => selectedValues.includes(value));

    return allSelected ? undefined : selectedValues;
  }

  function getData() {
    const params = {
      page: filter.page,
      search: filter.search,
      order: filter.order,
      access_system_ids: normalizedFilterValues(
        filter.access_system_ids,
        accessSystemOptions
      ),
    };

    axios
      .get(`/api/v1/gate_logs.json`, { params: params })
      .then(function (response) {
        setGateLogs(response.data);
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  function searchGateLogs(search) {
    let sanitizedSearch = search;
    sanitizedSearch = sanitizedSearch.replaceAll(":", "");

    setFilter({ ...filter, search: sanitizedSearch, page: 1 });
  }

  useEffect(() => {
    axios
      .get(`/api/v1/access_systems.json`)
      .then(function (response) {
        setAccessSystems(response.data.entries);
      })
      .catch(function (error) {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    getData();
  }, [filter]);

  return (
    <>
      <Card title={`Schranken Log (${gateLogs?.pagination?.count ?? 0})`}>
        <div>
          <Row className="filter-container">
            <Col md={6} xs={12}>
              <MultiSelectBox
                label="Zutrittssystem"
                options={accessSystemOptions}
                selectedValues={
                  filter.access_system_ids ??
                  accessSystemOptions.map((option) => option.value)
                }
                onChange={(accessSystemIds) =>
                  setFilter({
                    ...filter,
                    access_system_ids: accessSystemIds,
                    page: 1,
                  })
                }
              />
            </Col>
            <Col md={6} xs={12}>
              <Form.Group>
                <Form.Label>Suche</Form.Label>
                <div className="position-relative d-flex">
                  <div className="position-absolute p-2">
                    <FontAwesomeIcon icon={faSearch} />
                  </div>
                  <Form.Control
                    placeholder="Nach Gast oder NFC Karte suchen"
                    className="input-icon-p ui-input-bg"
                    type="text"
                    value={filter.search}
                    onChange={(e) => searchGateLogs(e.target.value)}
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
          <GateLogTable
            gateLogs={gateLogs}
            onPageClick={(page) => setFilter({ ...filter, page: page })}
          />
        </div>
      </Card>
    </>
  );
};

export default GateLogsPage;
